import { FC, useRef, useEffect } from 'react'
import { cn } from '@wellesley/ui'
import useLazyMedia from 'hooks/useLazyMedia'
import { isExtremeCase } from '@wellesley/uploads'
import { FileDesc } from '@wellesley/openapi'

type CmpProps = {
  src: string
  alt: string
  blurHash?: string | null
  className?: string
  imgHeight?: number | null
  mediaHeight?: number
  allowWithoutSize?: boolean
}

const LazyImage: FC<CmpProps> = ({
  src,
  alt,
  blurHash,
  imgHeight = 0,
  mediaHeight = 0,
  className,
  allowWithoutSize,
}) => {
  const { onLoad, isLoaded, isOnScreen, wrapperRef, placeholder } =
    useLazyMedia({
      blurHash,
    })

  const imgRef = useRef<HTMLImageElement>(null)

  useEffect(() => {
    const img = imgRef.current
    const src = img?.getAttribute('data-src')
    const canLoad = img && isOnScreen && !isLoaded && src

    if (canLoad) {
      img.src = src
    }
  }, [isLoaded, isOnScreen, imgRef.current])

  const isExtremeImage = isExtremeCase({
    meta: { height: imgHeight },
  } as FileDesc)

  const height = isExtremeImage
    ? imgHeight
    : mediaHeight
      ? mediaHeight
      : undefined

  return (
    <div
      ref={wrapperRef}
      style={{ height: allowWithoutSize ? 'auto' : `${height}px` }}
      className={cn('flex h-full', className)}
    >
      {placeholder}
      <img
        alt={alt}
        ref={imgRef}
        data-src={src}
        onLoad={onLoad}
        className={cn(className, 'h-full w-full max-w-full object-cover ', {
          'opacity-0': !isLoaded,
          'rounded-[3px]': isExtremeImage,
        })}
      />
    </div>
  )
}

export default LazyImage
